<template>
  <div style="text-align:center; margin-top: 100px;">
    <h1>403 Forbidden</h1>
    <p>You do not have permission to access this page.</p>
  </div>
</template>

<script>
export default {
  name: "Forbidden"
};
</script> 